module.exports = __webpack_public_path__ + "static/media/RectangularOutline.2ad4ee4d.png";